import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { UserHoverCardContent } from '@components/Feed/User/UserHoverCardContent';
import { AvatarUI } from '@components/main-components/avatar/Avatar';
import { VerifiedTooltip } from '@components/main-components/tooltip/VerifiedTooltip';
import { UserHoverCard } from '@components/main-components/user/UserHoverCard';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, NotificationUserFragmentDoc } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment NotificationUser on User {
    id
    publicAddress
    webappUri
    username
    avatar {
      id
      url
    }
    artist {
      id
    }
  }
`);

export const NotificationUser = ({
  userFrag,
  disableLink,
}: {
  userFrag: FragmentType<NotificationUserFragmentDoc>;
  disableLink?: boolean;
}) => {
  const {
    id: userId,
    username,
    avatar,
    publicAddress,
    webappUri,
    artist,
  } = getFragment(NotificationUserFragmentDoc, userFrag);

  const isArtist = !!artist?.id;

  const avatarUI = (
    <div className="flex aspect-square h-10 w-10 flex-shrink-0 rounded-full ">
      <AvatarUI
        src={avatar?.url}
        username={username}
        walletAddress={publicAddress}
        size={40}
        webappUriPath={webappUriPath(webappUri)}
        borderRadius="50%"
        priority
        disableLink={disableLink}
      />
    </div>
  );

  const hoverCardTrigger = (
    <div className="relative inline-flex items-center gap-2 md:gap-3">
      {avatarUI}
      <div className="hidden items-center overflow-hidden dt:flex">
        <span className="max-w-[120px] items-center overflow-hidden text-ellipsis whitespace-nowrap font-semibold dt:max-w-[250px]">
          {username}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <div className="flex flex-shrink-0 dt:hidden">{avatarUI}</div>
      <div className="hidden items-center gap-0.5 dt:flex">
        <UserHoverCard
          userHoverCardContent={<UserHoverCardContent userId={userId} />}
          trigger={hoverCardTrigger}
          triggerAsChild
        />
        {isArtist && (
          <>
            <span className="block md:hidden">
              <VerifiedTooltip size={16} />
            </span>
            <span className="hidden md:block">
              <VerifiedTooltip size={18} />
            </span>
          </>
        )}
      </div>
    </>
  );
};
